import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  FileUpload: { input: any; output: any; }
}

export interface Company {
  __typename?: 'Company';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  unrealVersion: Scalars['String']['output'];
}

export interface Country {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface CreateDownloadInput {
  renderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  spinnerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
}

export interface CreateDownloadPayload {
  __typename?: 'CreateDownloadPayload';
  download?: Maybe<Download>;
}

export interface CreatePasswordResetRequestInput {
  email: Scalars['String']['input'];
  resetLink: Scalars['String']['input'];
}

export interface CreatePasswordResetRequestPayload {
  __typename?: 'CreatePasswordResetRequestPayload';
  success: Scalars['Boolean']['output'];
}

export interface Download {
  __typename?: 'Download';
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
}

export interface GenerateTokenInput {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}

export interface Mutation {
  __typename?: 'Mutation';
  createDownload?: Maybe<CreateDownloadPayload>;
  createPasswordResetRequest?: Maybe<CreatePasswordResetRequestPayload>;
  generateToken?: Maybe<TokensPayload>;
  refreshToken?: Maybe<TokensPayload>;
  resetPassword?: Maybe<TokensPayload>;
  updateMe?: Maybe<UpdateMePayload>;
  updatePassword?: Maybe<UpdatePasswordPayload>;
}


export interface MutationCreateDownloadArgs {
  input: CreateDownloadInput;
}


export interface MutationCreatePasswordResetRequestArgs {
  input: CreatePasswordResetRequestInput;
}


export interface MutationGenerateTokenArgs {
  input: GenerateTokenInput;
}


export interface MutationRefreshTokenArgs {
  input: RefreshTokenInput;
}


export interface MutationResetPasswordArgs {
  input: ResetPasswordInput;
}


export interface MutationUpdateMeArgs {
  input: UpdateMeInput;
}


export interface MutationUpdatePasswordArgs {
  input: UpdatePasswordInput;
}

export interface Query {
  __typename?: 'Query';
  countries?: Maybe<Array<Maybe<Country>>>;
  me?: Maybe<User>;
  status: Scalars['String']['output'];
  timezones?: Maybe<Array<Maybe<Timezone>>>;
  token?: Maybe<Scalars['String']['output']>;
}

export interface RefreshTokenInput {
  refreshToken: Scalars['String']['input'];
}

export interface ResetPasswordInput {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}

export interface Timezone {
  __typename?: 'Timezone';
  id: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface TokensPayload {
  __typename?: 'TokensPayload';
  refreshToken?: Maybe<Scalars['String']['output']>;
  refreshTokenExpiration?: Maybe<Scalars['Int']['output']>;
  token: Scalars['String']['output'];
}

export interface UpdateMeInput {
  avatar?: InputMaybe<Scalars['FileUpload']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  timezoneId?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateMePayload {
  __typename?: 'UpdateMePayload';
  me?: Maybe<User>;
}

export interface UpdatePasswordInput {
  newPassword: Scalars['String']['input'];
  newPasswordRepeat: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
}

export interface UpdatePasswordPayload {
  __typename?: 'UpdatePasswordPayload';
  me?: Maybe<User>;
}

export interface User {
  __typename?: 'User';
  avatarPath?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  country?: Maybe<Country>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Maybe<UserRolesEnum>>>;
  settings: UserSettings;
  state?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Timezone>;
}

export enum UserRolesEnum {
  RoleCompanyAdmin = 'ROLE_COMPANY_ADMIN',
  RoleCompanyUser = 'ROLE_COMPANY_USER',
  RoleSuperAdmin = 'ROLE_SUPER_ADMIN'
}

export interface UserSettings {
  __typename?: 'UserSettings';
  allow_add_files: Scalars['Boolean']['output'];
  allow_copy_asset: Scalars['Boolean']['output'];
  allow_delete_asset: Scalars['Boolean']['output'];
  allow_delete_render: Scalars['Boolean']['output'];
  allow_delete_spinner: Scalars['Boolean']['output'];
  allow_embed: Scalars['Boolean']['output'];
  allow_lighting_presets: Scalars['Boolean']['output'];
  allow_manage_materials: Scalars['Boolean']['output'];
  allow_render_360: Scalars['Boolean']['output'];
  allow_render_jpg: Scalars['Boolean']['output'];
  allow_render_png: Scalars['Boolean']['output'];
  allow_render_tiff: Scalars['Boolean']['output'];
}

export type GenerateTokenMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type GenerateTokenMutation = { __typename?: 'Mutation', generateToken?: { __typename?: 'TokensPayload', token: string, refreshToken?: string | null } | null };

export type RefreshTokenMutationVariables = Exact<{
  input: RefreshTokenInput;
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken?: { __typename?: 'TokensPayload', token: string, refreshToken?: string | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'TokensPayload', token: string } | null };

export type CreatePasswordResetRequestMutationVariables = Exact<{
  input: CreatePasswordResetRequestInput;
}>;


export type CreatePasswordResetRequestMutation = { __typename?: 'Mutation', createPasswordResetRequest?: { __typename?: 'CreatePasswordResetRequestPayload', success: boolean } | null };

export type UpdatePasswordMutationVariables = Exact<{
  input: UpdatePasswordInput;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword?: { __typename?: 'UpdatePasswordPayload', me?: { __typename?: 'User', id: string } | null } | null };

export type CreateDownloadMutationVariables = Exact<{
  input: CreateDownloadInput;
}>;


export type CreateDownloadMutation = { __typename?: 'Mutation', createDownload?: { __typename?: 'CreateDownloadPayload', download?: { __typename?: 'Download', link?: string | null } | null } | null };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, avatarPath?: string | null, roles?: Array<UserRolesEnum | null> | null, email?: string | null, firstName?: string | null, lastName?: string | null, state?: string | null, city?: string | null, company?: { __typename?: 'Company', id: string, name?: string | null, unrealVersion: string } | null, settings: { __typename?: 'UserSettings', allow_add_files: boolean, allow_copy_asset: boolean, allow_render_360: boolean, allow_render_png: boolean, allow_render_jpg: boolean, allow_delete_asset: boolean, allow_delete_render: boolean, allow_delete_spinner: boolean, allow_manage_materials: boolean }, country?: { __typename?: 'Country', code: string, name: string } | null, timezone?: { __typename?: 'Timezone', id: string, value: string } | null } | null };

export type UpdateMeMutationVariables = Exact<{
  input: UpdateMeInput;
}>;


export type UpdateMeMutation = { __typename?: 'Mutation', updateMe?: { __typename?: 'UpdateMePayload', me?: { __typename?: 'User', id: string, avatarPath?: string | null, roles?: Array<UserRolesEnum | null> | null, email?: string | null, firstName?: string | null, lastName?: string | null, state?: string | null, city?: string | null, company?: { __typename?: 'Company', id: string, name?: string | null, unrealVersion: string } | null, settings: { __typename?: 'UserSettings', allow_add_files: boolean, allow_copy_asset: boolean, allow_render_360: boolean, allow_render_png: boolean, allow_render_jpg: boolean, allow_delete_asset: boolean, allow_delete_render: boolean, allow_delete_spinner: boolean, allow_manage_materials: boolean }, country?: { __typename?: 'Country', code: string, name: string } | null, timezone?: { __typename?: 'Timezone', id: string, value: string } | null } | null } | null };

export type TimezonesQueryVariables = Exact<{ [key: string]: never; }>;


export type TimezonesQuery = { __typename?: 'Query', timezones?: Array<{ __typename?: 'Timezone', id: string, value: string } | null> | null };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', countries?: Array<{ __typename?: 'Country', code: string, name: string } | null> | null };

export const GenerateTokenDocument = gql`
    mutation generateToken($email: String!, $password: String!) {
  generateToken(input: {email: $email, password: $password}) {
    token
    refreshToken
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateTokenGQL extends Apollo.Mutation<GenerateTokenMutation, GenerateTokenMutationVariables> {
    document = GenerateTokenDocument;
    client = 'legacy';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RefreshTokenDocument = gql`
    mutation refreshToken($input: RefreshTokenInput!) {
  refreshToken(input: $input) {
    token
    refreshToken
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RefreshTokenGQL extends Apollo.Mutation<RefreshTokenMutation, RefreshTokenMutationVariables> {
    document = RefreshTokenDocument;
    client = 'legacy';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetPasswordDocument = gql`
    mutation resetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input) {
    token
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetPasswordGQL extends Apollo.Mutation<ResetPasswordMutation, ResetPasswordMutationVariables> {
    document = ResetPasswordDocument;
    client = 'legacy';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePasswordResetRequestDocument = gql`
    mutation createPasswordResetRequest($input: CreatePasswordResetRequestInput!) {
  createPasswordResetRequest(input: $input) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePasswordResetRequestGQL extends Apollo.Mutation<CreatePasswordResetRequestMutation, CreatePasswordResetRequestMutationVariables> {
    document = CreatePasswordResetRequestDocument;
    client = 'legacy';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePasswordDocument = gql`
    mutation updatePassword($input: UpdatePasswordInput!) {
  updatePassword(input: $input) {
    me {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePasswordGQL extends Apollo.Mutation<UpdatePasswordMutation, UpdatePasswordMutationVariables> {
    document = UpdatePasswordDocument;
    client = 'legacy';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDownloadDocument = gql`
    mutation createDownload($input: CreateDownloadInput!) {
  createDownload(input: $input) {
    download {
      link
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDownloadGQL extends Apollo.Mutation<CreateDownloadMutation, CreateDownloadMutationVariables> {
    document = CreateDownloadDocument;
    client = 'legacy';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserDocument = gql`
    query getUser {
  me {
    id
    avatarPath
    roles
    email
    firstName
    lastName
    state
    city
    company {
      id
      name
      unrealVersion
    }
    settings {
      allow_add_files
      allow_copy_asset
      allow_render_360
      allow_render_png
      allow_render_jpg
      allow_delete_asset
      allow_delete_render
      allow_delete_spinner
      allow_manage_materials
    }
    country {
      code
      name
    }
    timezone {
      id
      value
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserGQL extends Apollo.Query<GetUserQuery, GetUserQueryVariables> {
    document = GetUserDocument;
    client = 'legacy';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMeDocument = gql`
    mutation updateMe($input: UpdateMeInput!) {
  updateMe(input: $input) {
    me {
      id
      avatarPath
      roles
      email
      firstName
      lastName
      state
      city
      company {
        id
        name
        unrealVersion
      }
      settings {
        allow_add_files
        allow_copy_asset
        allow_render_360
        allow_render_png
        allow_render_jpg
        allow_delete_asset
        allow_delete_render
        allow_delete_spinner
        allow_manage_materials
      }
      country {
        code
        name
      }
      timezone {
        id
        value
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMeGQL extends Apollo.Mutation<UpdateMeMutation, UpdateMeMutationVariables> {
    document = UpdateMeDocument;
    client = 'legacy';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TimezonesDocument = gql`
    query timezones {
  timezones {
    id
    value
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TimezonesGQL extends Apollo.Query<TimezonesQuery, TimezonesQueryVariables> {
    document = TimezonesDocument;
    client = 'legacy';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CountriesDocument = gql`
    query countries {
  countries {
    code
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CountriesGQL extends Apollo.Query<CountriesQuery, CountriesQueryVariables> {
    document = CountriesDocument;
    client = 'legacy';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }